import { clsx } from 'clsx'

export default function SignalBadge({ signal, size = 'sm' }) {
  const isStop = signal === 'STOP'

  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1.5 rounded-md font-bold tracking-wide uppercase',
        size === 'sm' && 'px-2 py-0.5 text-xs',
        size === 'md' && 'px-3 py-1 text-sm',
        size === 'lg' && 'px-4 py-1.5 text-base',
        isStop
          ? 'bg-red-500/20 text-red-300 border border-red-500/40 stop-pulse'
          : 'bg-emerald-500/15 text-emerald-400 border border-emerald-500/30'
      )}
    >
      {/* Status dot */}
      <span
        className={clsx(
          'block w-1.5 h-1.5 rounded-full',
          isStop ? 'bg-red-400 animate-pulse' : 'bg-emerald-400'
        )}
      />
      {signal ?? 'GO'}
    </span>
  )
}
